import { inject, Injectable } from '@angular/core';
import { PriceListService, SqliteService } from '@app/services';
import { PriceListModel } from '@app/models';

@Injectable({
    providedIn: 'root',
})
export class PriceListRepository
{
    private readonly keys = {
        tableName: 'price_lists',
    };
    private sqliteService = inject(SqliteService);
    private priceListService = inject(PriceListService);

    async getPriceLists(): Promise<PriceListModel[]>
    {
        const sql = `
            SELECT *
            FROM ${this.keys.tableName};
        `;

        const data = await this.sqliteService.get(sql) ?? [];

        return data as PriceListModel[];
    }

    async downloadPriceLists(): Promise<any[]>
    {
        const prices = await this.priceListService.getPriceLists();

        if (prices.length > 0)
        {
            await this.savePriceLists(prices);
        }

        return prices;
    }

    async savePriceLists(prices: PriceListModel[]): Promise<void>
    {
        const columns = [
            'id',
            'external_id',
            'store_external_id',
            'product_external_id',
            'route_external_id',
            'price'
        ];
        const batchSize = Math.floor(3000 / columns.length);

        for (let i = 0; i < prices.length; i += batchSize)
        {
            const chunk = prices.slice(i, i + batchSize);

            const valuePlaceholders = this.sqliteService.getValuePlaceholder(
                chunk.length,
                columns.length
            );

            const sql = `
                INSERT INTO ${this.keys.tableName} (${columns.join(', ')})
                VALUES ${valuePlaceholders} ON CONFLICT(id) DO
                UPDATE SET
                    external_id = excluded.external_id,
                    product_external_id = excluded.product_external_id,
                    route_external_id = excluded.route_external_id,
                    price = excluded.price,
                    store_external_id = excluded.store_external_id;
            `;

            const values = chunk.flatMap((r) => [
                r.id,
                r.external_id,
                r.store_external_id,
                r.product_external_id,
                r.route_external_id,
                r.price,
            ]);

            await this.sqliteService.save(sql, values);
        }
    }
}
